import React from 'react'
import { makeStyles } from '@material-ui/styles'
import PaperWithPadding from 'components/templates/PaperWithPadding'
import HorizontalWidget from '../organisms/HorizontalWidget'
import useInitialProps from '../../hooks/useStaticContext'

const useStyles = makeStyles({
  root: {
    width: 'fit-content',
  },
})

const HorizontalWidgetPage = ({ staticContext }) => {
  const {
    handicaps = {},
    picture = null,
    cardUrl = null,
  } = useInitialProps(staticContext)
  const classes = useStyles()

  return (
    handicaps && (
      <PaperWithPadding padding={0.5} className={classes.root}>
        <HorizontalWidget
          handicaps={handicaps}
          cardUrl={cardUrl}
          picture={picture}
        />
      </PaperWithPadding>
    )
  )
}
export default HorizontalWidgetPage
